<div class="d-flex justify-content-between flex-row flex-wrap gap-3 mb-4">

  <h4 class="d-flex text-primary">Manage Organization Admins</h4>
  
  <button
    [disableWithoutPermission]="{ requiredPermissions: [RolePermission.OrgAdmin], userPermissionOnly: false }"
    type="button"
    class="btn btn-primary d-flex ms-icon-text gap-2"
    [disabled]="isLoading()"
    (click)="openMemberSelector()">
    <fa-duotone-icon icon="user-plus" />
    <span>Add Admin</span>
  </button>
</div>

@if (!dismissibleNotesService.isDismissed(elevatedPrivilegesWarningDismissKey, organization().organizationId)) {
  <div class="alert alert-warning alert-dismissible d-flex ms-icon-text gap-2" role="alert">
    <fa-duotone-icon icon="circle-info" />
    <div><strong>Note:</strong> {{ elevatedPrivilegesWarning }}</div>
    <button type="button" class="btn-close" aria-label="Dismiss"
      (click)="dismissibleNotesService.dismiss(elevatedPrivilegesWarningDismissKey, organization().organizationId)"></button>
  </div>
}

@if (errorMessage()) {
  <div class="alert alert-danger d-flex ms-icon-text gap-2" role="alert">
    <fa-duotone-icon icon="circle-exclamation" />
    <div>{{ errorMessage() }}</div>
  </div>
}

@if (!errorMessage()) {
  <div class="row mb-4">
    <div class="col-12">

      @if (isLoading()) {
        <div class="d-flex align-items-center mb-2">
          <div class="placeholder-glow w-100">
            <span class="placeholder col-8"></span>
          </div>
        </div>
        <div class="d-flex align-items-center mb-2">
          <div class="placeholder-glow w-100">
            <span class="placeholder col-6"></span>
          </div>
        </div>
      } @else if (currentAdmins().length > 0) {
        <div class="list-group">
          @for (admin of currentAdmins(); track admin.memberId) {
            <div class="list-group-item d-flex flex-wrap justify-content-between align-items-center gap-3">
              <div class="d-flex align-items-center gap-3 min-w-0 flex-grow-1">
                <ms-avatar 
                  [identity]="admin"
                  [avatarSize]="avatarSize"
                  [avatarShape]="avatarShape"
                  [avatarAdditionalAttributes]="avatarAdditionalAttributes"
                />
                <div class="min-w-0">
                  <div class="fs-6 fw-semibold text-truncate"
                    [msTooltip]="admin.firstName + ' ' + admin.lastName" msTooltipOnlyIfTruncated>{{ admin.firstName }} {{ admin.lastName }}</div>
                  <div class="text-muted small text-truncate"
                    [msTooltip]="admin.emailAddress ?? ''" msTooltipOnlyIfTruncated>{{ admin.emailAddress }}</div>
                </div>
              </div>
              <button
                [disableWithoutPermission]="{ requiredPermissions: [RolePermission.OrgAdmin], userPermissionOnly: false }"
                type="button"
                class="btn btn-sm btn-danger d-flex ms-icon-text gap-1 flex-shrink-0"
                (click)="confirmRevokeAdmin(admin)">
                <fa-duotone-icon icon="user-minus" />
                <span>Unassign Admin</span>
              </button>
            </div>
          }
        </div>
      } @else {
        <p class="text-muted">No admins currently assigned</p>
      }
    </div>
  </div>
}


<!-- Member Selector Modal -->
<div class="modal fade" id="manageAdminsMemberSelectorModal" tabindex="-1" aria-labelledby="manageAdminsMemberSelectorModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="manageAdminsMemberSelectorModalLabel">Select Member to Grant Admin Role</h5>
      </div>
      <div class="modal-body">        
        <ms-member-list
          [currentMemberListViewLocation]="MemberListViewLocations.ManageOrganizationAdminsModal"
          [filterRoleId]="orgMemberRoleId()"
          [transferringOrgId]="organization().organizationId"
          [excludeMemberIds]="currentAdminIds()"
          (memberSelectedForOwnershipTransfer)="onMemberSelectedForAdmin($event)"
        />
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-ms-secondary" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Grant Admin Confirmation Modal -->
<ms-confirmation-modal 
  #grantAdminConfirmationModalRef
  modalId="grantAdminConfirmationModal"
  [isSubmitting]="isSubmitting()"
  (confirmed)="onGrantAdminConfirmed()"
  (cancelled)="onGrantAdminCancelled()"
/>

<!-- Revoke Admin Confirmation Modal -->
<ms-confirmation-modal 
  #revokeAdminConfirmationModalRef
  modalId="revokeAdminConfirmationModal"
  [isSubmitting]="isSubmitting()"
  (confirmed)="onRevokeAdminConfirmed()"
  (cancelled)="onRevokeAdminCancelled()"
/>

<!-- Admin Action Result Info Modal -->
<ms-info-modal 
  #adminInfoModalRef
  modalId="adminInfoModal"
/>
